import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IPopupSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IPopupSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { commonCodeStore } = useStores();
  const environmentOptions = commonCodeStore.getCCodeByName('POPUP_ENV_CD') ?? [];
  const methods = useForm<IPopupSFilter>({
    defaultValues: {
      searchText: '',
      popupEnvCd: '',
    },
  });
  const { t } = useTranslation();

  // 검색 함수
  const onValid = (data: IPopupSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true} cols={2}>
        <FormItem>
          <RHFTextField label={t('popup.fields.searchText.name')} name="searchText" />
        </FormItem>
        <FormItem>
          <RHFSelect
            label={t('popup.fields.popupEnvCd.name')}
            name="popupEnvCd"
            options={environmentOptions}
          />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
